var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9875 6.99541V3.99739C18.9875 3.73235 18.8822 3.47816 18.6948 3.29075C18.5074 3.10333 18.2532 2.99805 17.9882 2.99805H4.99673C4.46665 2.99805 3.95827 3.20862 3.58345 3.58345C3.20862 3.95827 2.99805 4.46665 2.99805 4.99673C2.99805 5.52681 3.20862 6.03519 3.58345 6.41001C3.95827 6.78484 4.46665 6.99541 4.99673 6.99541H19.9869C20.2519 6.99541 20.5061 7.1007 20.6935 7.28811C20.8809 7.47553 20.9862 7.72971 20.9862 7.99476V11.9921M20.9862 11.9921H17.9882C17.4581 11.9921 16.9497 12.2027 16.5749 12.5775C16.2001 12.9523 15.9895 13.4607 15.9895 13.9908C15.9895 14.5209 16.2001 15.0293 16.5749 15.4041C16.9497 15.7789 17.4581 15.9895 17.9882 15.9895H20.9862C21.2512 15.9895 21.5054 15.8842 21.6928 15.6968C21.8803 15.5094 21.9855 15.2552 21.9855 14.9901V12.9915C21.9855 12.7264 21.8803 12.4722 21.6928 12.2848C21.5054 12.0974 21.2512 11.9921 20.9862 11.9921Z",
    stroke: "white",
    strokeWidth: 1.99868,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99805 4.99609V18.9869C2.99805 19.517 3.20862 20.0253 3.58345 20.4002C3.95827 20.775 4.46665 20.9856 4.99673 20.9856H19.9869C20.2519 20.9856 20.5061 20.8803 20.6935 20.6929C20.8809 20.5054 20.9862 20.2513 20.9862 19.9862V15.9889",
    stroke: "white",
    strokeWidth: 1.99868,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/WalletIcon.ee990702e7f8fb871f82aca5de6b187c.svg";
export { ForwardRef as ReactComponent };